package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** Moderation lifecycle of a business listing. Only [Approved] is publicly readable (Firestore rules). */
@Serializable
enum class BusinessStatus {
    @SerialName("pending") Pending,
    @SerialName("approved") Approved,
    @SerialName("rejected") Rejected,
    @SerialName("suspended") Suspended,
}

/** Ownership-claim state for a listing. Seeded directory candidates start [Unclaimed]. */
@Serializable
enum class ClaimStatus {
    @SerialName("unclaimed") Unclaimed,
    @SerialName("claim_requested") ClaimRequested,
    @SerialName("claimed") Claimed,
}

/** Source of a listing's imagery — drives the placeholder fallback until an owner uploads media. */
@Serializable
enum class MediaStatus {
    @SerialName("category_placeholder_pending") CategoryPlaceholderPending,
    @SerialName("category_placeholder") CategoryPlaceholder,
    @SerialName("owner_media") OwnerMedia,
}

/** Where a sponsorship grants boosted placement. */
@Serializable
enum class SponsorshipScope {
    @SerialName("city") City,
    @SerialName("category") Category,
    @SerialName("top") Top,
}
